export default __webpack_public_path__ + "static/media/Girdle of the Painlegion.4b67b35b.jpg";